<div *ngIf="content.type === 'full-page'; else singleError">
  <section class="full-page-error-message__container">
    <div class="full-page-error-message__container--message">
      <span class="full-page-error-message__container--body">
        <i
          aria-hidden="true"
          class="full-page-error-message__container--icon"
        ></i>
        <span class="full-page-error-message__container--text">
          {{ content.message.subtitle }}
        </span>
      </span>
    </div>
    <div class="full-page-error-message__container--btn-section">
      <idp-button
        [label]="content.action.label"
        [size]="'full-width'"
        [type]="'primary'"
        [ariaLabel]="content.action.label"
        [ariaPopup]="false"
        (notify)="redirect(content.action.url, 'button')"
      ></idp-button>
    </div>
  </section>
</div>
<ng-template #singleError>
  <h3 *ngIf="content.featureTitle" class="single-error-message--header">
    <span>
      {{ content.featureTitle }}
    </span>
  </h3>
  <div class="single-error-message">
    <span class="single-error-message--body">
      <i aria-hidden="true" class="single-error-message--icon"></i>
      <span class="single-error-message--text">
        {{ content.message.title }}
      </span>
    </span>
    <idp-link
      *ngIf="content.type !== 'message-error'"
      class="single-error-message--link"
      [label]="content.action.label"
      [axLabel]="content.action.label"
      [actionUrl]="content.action.url"
      [labelSize]="'large'"
    ></idp-link>
  </div>
</ng-template>
